import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "./CreditOperations.css";
import DynamicTable from "../../Table";

const TABS = [
  { key: "user", label: "For User" },
  { key: "bulk", label: "Bulk Sale" },
  { key: "payment", label: "Payment Control" },
];

// Tabbed operations card: add credit for a user, generate bulk-sale codes,
// and check payments by date range. State is owned by the page; this component
// only renders inputs and calls back.
export default function CreditOperations(props) {
  const {
    // For user
    startDate,
    setStartDate,
    enddate,
    setEndDate,
    onAddCredit,
    // Bulk
    codeLength,
    setCodeLength,
    count,
    onCountChange,
    promotionName,
    setPromotionName,
    startDateBulk,
    setStartDateBulk,
    enddateBulk,
    setEndDateBulk,
    onAddCreditBulk,
    bulkCredit = [],
    // Payment
    startDateForBill,
    setStartDateForBill,
    endDateForBill,
    setEndDateForBill,
    price,
    setPrice,
    onCheckPayment,
    paidUsers,
    isTablet,
  } = props;

  const [activeTab, setActiveTab] = useState("user");

  return (
    <div className="credit-ops">
      <div className="credit-ops-tabs" role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`credit-ops-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="credit-ops-body">
        {activeTab === "user" && (
          <div className="credit-ops-panel">
            <h4 className="credit-ops-title">Kullanıcıya Kredi Ekle</h4>
            <div className="credit-ops-fields">
              <label className="credit-field">
                <span className="credit-field-label">Başlangıç Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Bitiş Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={enddate}
                  onChange={(date) => setEndDate(date)}
                />
              </label>
            </div>
            <button
              type="button"
              className="credit-btn credit-btn-primary"
              onClick={onAddCredit}
            >
              Add Credit
            </button>
          </div>
        )}

        {activeTab === "bulk" && (
          <div className="credit-ops-panel">
            <h4 className="credit-ops-title">Toplu Satış Kredisi</h4>
            <div className="credit-ops-fields">
              <label className="credit-field">
                <span className="credit-field-label">Kod Uzunluğu</span>
                <input
                  className="credit-input"
                  type="text"
                  value={codeLength}
                  placeholder="Kod Uzunluğu"
                  onChange={(e) => setCodeLength(e.currentTarget.value)}
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Adet (1-10)</span>
                <input
                  className="credit-input"
                  type="number"
                  max="10"
                  min="1"
                  value={count}
                  placeholder="Adet"
                  onChange={(e) => onCountChange(e)}
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Promosyon Adı</span>
                <input
                  className="credit-input"
                  type="text"
                  value={promotionName}
                  placeholder="Promosyon Adı"
                  onChange={(e) => setPromotionName(e.currentTarget.value)}
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Başlangıç Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={startDateBulk}
                  onChange={(date) => setStartDateBulk(date)}
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Bitiş Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={enddateBulk}
                  onChange={(date) => setEndDateBulk(date)}
                />
              </label>
            </div>
            <button
              type="button"
              className="credit-btn credit-btn-primary"
              onClick={onAddCreditBulk}
            >
              Add Credit
            </button>

            {bulkCredit.length > 0 && (
              <div className="credit-ops-codes">
                <div className="credit-ops-codes-title">
                  Üretilen Kodlar ({bulkCredit.length})
                </div>
                <ul className="credit-ops-codes-list">
                  {bulkCredit.map((code, i) => (
                    <li key={i}>{code}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}

        {activeTab === "payment" && (
          <div className="credit-ops-panel">
            <h4 className="credit-ops-title">Ödeme Kontrol</h4>
            <div className="credit-ops-fields">
              <label className="credit-field">
                <span className="credit-field-label">Başlangıç Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={startDateForBill}
                  onChange={(date) => setStartDateForBill(date)}
                  timeInputLabel="Saat:"
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeInput
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Bitiş Tarihi</span>
                <DatePicker
                  className="credit-input"
                  selected={endDateForBill}
                  onChange={(date) => setEndDateForBill(date)}
                  timeInputLabel="Saat:"
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeInput
                />
              </label>
              <label className="credit-field">
                <span className="credit-field-label">Alınan Ödeme Tutarı</span>
                <input
                  className="credit-input"
                  type="text"
                  placeholder="Alınan Ödeme Tutarı"
                  value={price}
                  onChange={(e) => setPrice(e.currentTarget.value)}
                />
              </label>
            </div>
            <button
              type="button"
              className="credit-btn credit-btn-primary"
              onClick={onCheckPayment}
            >
              Check Payment
            </button>

            {paidUsers && (
              <div className="credit-ops-paid">
                <div className="credit-ops-paid-title">Ödeme Yapan Kullanıcılar</div>
                {paidUsers.length > 0 ? (
                  <DynamicTable data={paidUsers} isTablet={isTablet} />
                ) : (
                  <div className="credit-ops-paid-empty">
                    Ödeme yapan kullanıcı bulunamadı.
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
